module.exports = __webpack_public_path__ + "img/P150T_weapon_118.63b486e9.png";